import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
const getIsUngated = gateName => {
  const {
    gates
  } = userInfoSync();
  return gates.includes(gateName);
};
export const isUngatedToCHIRPEndpoints = () => {
  return getIsUngated(gate('BuyerExperience:SalesDocumentsCHIRPMigration'));
};